import React from 'react';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';

export default function DragAndDrop({ children, onDragEnd, type, droppableId }) {
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId={droppableId || 'items'} type={type}>
        {provided => (
          <div ref={provided.innerRef} {...provided.droppableProps}>
            {children}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
}
